import { render, staticRenderFns } from "./NetworkPartnerNew.vue?vue&type=template&id=40c9b4ca&scoped=true&"
import script from "./NetworkPartnerNew.vue?vue&type=script&lang=js&"
export * from "./NetworkPartnerNew.vue?vue&type=script&lang=js&"
import style0 from "./NetworkPartnerNew.vue?vue&type=style&index=0&id=40c9b4ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9b4ca",
  null
  
)

export default component.exports